import ChartActions from '../chart-actions/chart-actions';
import React from 'react';
import { DataReportActions } from '../../types/response';

type ReportActionsProps = {
  data: DataReportActions
  selectedYear: number
}

function ReportActions({ data, selectedYear }: ReportActionsProps) {
  return (
    <div className="rounded-lg bg-white p-4 shadow-md">
      <ChartActions
        data={data.data}
        openActions={data.openActions}
        closeActions={data.closeActions}
        selectedYear={selectedYear}
      />
    </div>
  );
}

export default ReportActions;
